import { isUnknownObject, isNumber } from '~/shared/utils/guards'
import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'

export default class VacancyInterlinksItem extends BaseModel {
  static override constructorName = 'VacancyInterlinksItem'

  name: string = ''
  link: string = ''
  'doc_count': string = ''
  hidden: boolean = false

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      if (isNumber(data.doc_count)) {
        this.doc_count = String(data.doc_count)
      }
    }
  }
}

registerModel(VacancyInterlinksItem)
